
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface BlogHeaderProps {
  title: string;
  subtitle?: string;
  date: string;
  category?: string;
  coverImage?: string;
  imageAlt?: string;
}

const BlogHeader: React.FC<BlogHeaderProps> = ({ 
  title,
  subtitle,
  date, 
  category,
  coverImage,
  imageAlt = "Blog header image" 
}) => {
  return (
    <header className="mb-8 relative">
      <h1 className="text-3xl md:text-4xl font-bold font-serif tracking-tight mb-4" itemProp="headline" data-speakable="headline">{title}</h1>
      {subtitle && (
        <p className="text-lg md:text-xl text-muted-foreground font-serif italic -mt-2 mb-6" data-speakable="description">{subtitle}</p>
      )}
      
      {coverImage && (
        <div className="relative mb-8 mt-6 overflow-hidden rounded-xl border border-joerg-200">
          <AspectRatio ratio={16/9} className="bg-joerg-100">
            <img 
              src={coverImage} 
              alt={imageAlt} 
              className="h-full w-full object-cover"
              loading="eager"
              fetchPriority="high"
              decoding="sync"
              itemProp="image" 
            />
          </AspectRatio>
        </div>
      )}
    </header>
  );
};

export default BlogHeader;
